import GroupInfo from 'Container/Groups/GroupsInfoContainer';
import BroadcastMgMt from 'Container/BroadCast/ManageBroadCast/BroadCastContainer';
import Broadcast from 'Components/Broadcast';
import BroadcastTeam from 'Container/BroadCast/Team/TeamContainer';
import ManageAdmin from 'Container/ManageAdmin/ManageAdminContainer';
import ManageAdminRoles from 'Container/ManageRoles/ManageAdminRoles';
import Settings from 'Container/Settings/SettingContainer';
import MyProfile from 'Container/Profile/MyProfileContainer';
import ChangePassword from 'Container/ChangePasswordContainer';
import Coming from 'Components/ComingSoon';
import UserDetails from 'Container/Users/userDetailsContainer';
import UserList from 'Container/Users/usersListContainer';
import Group from 'Container/Groups/GroupsContainer';
import Feedback from 'Container/Feedback';
import CallManagement from 'Container/CallManagement';
import Dashboard from 'Components/Dashboard'
import AddTeam from 'Container/BroadCast/Team/AddTeamContainer';
import EditTeam from 'Container/BroadCast/Team/EditTeamContainer';
import Help from 'Container/Help';
import routesPath from 'Constants/routes.constants';
import AppAccessControl from 'Container/AppAccessControl';
import { Modules } from 'Constants/Modules.constants';
import Reports from 'Container/Feedback/index.js';
import ReplyFeedback from 'Container/Feedback/ReplyFeedbackContainer';

const dashboardRoutes = [
  {
    path: routesPath.root,
    name: '',
    icon: null,
    component: Dashboard,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.userManagement,
    name: 'Users',
    component: UserList,
    icon: null,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.comingSoon,
    name: 'comingsoon',
    icon: null,
    exact: true,
    component: Coming,
    route: 'public'
  },
  {
    path: routesPath.groups,
    name: 'Groups',
    icon: null,
    exact: true,
    route: 'private',
    component: Group,
  },
  {
    path: routesPath.groupInfoWithId(':id'),
    name: 'Groups',
    icon: null,
    component: GroupInfo,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.broadcast,
    name: 'Broadcast',
    icon: null,
    component: Broadcast,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.manageBroadcast,
    name: 'Broadcast',
    icon: null,
    component: BroadcastMgMt,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.broadcastTeam,
    name: 'Team',
    icon: null,
    component: BroadcastTeam,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.broadcastTeamAdd,
    name: 'Team',
    icon: null,
    component: AddTeam,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.broadcastTeamEdit(':id'),
    name: 'Team',
    icon: null,
    component: EditTeam,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.manageAdmin,
    name: 'Manage admin',
    icon: null,
    component: ManageAdmin,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.manageAdminRoles,
    name: 'Manage admin roles',
    icon: null,
    component: ManageAdminRoles,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.feedback,
    name: 'Feedback',
    icon: null,
    component: Feedback,
    exact: true,
    route: 'public'
  },
  // {
  //   path: routesPath.help,
  //   name: 'help',
  //   icon: null,
  //   component: Help,
  //   exact: true,
  //   route: 'private'
  // },
  {
    path: routesPath.settings,
    name: 'Settings',
    icon: null,
    component: Settings,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.profileMyprofile,
    name: '',
    icon: null,
    component: MyProfile,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.profileChangepassword,
    name: '',
    icon: null,
    component: ChangePassword,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.callManagement,
    name: 'Call management',
    icon: null,
    component: CallManagement,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.appAccessControl,
    name: Modules.appAccessControl,
    icon: null,
    component: AppAccessControl,
    exact: true,
    route: 'private'
  },
  {
    path: routesPath.report,
    name: Modules.report,
    icon: null,
    component: Reports,
    exact: true,
    route: 'public'
  },
  {
    path: routesPath.detailReport,
    name: Modules.report,
    icon: null,
    component: ReplyFeedback,
    exact: true,
    route: 'public'
  }
  // {
  //   path: routesPath.userManagementWithId(':id'),
  //   name: 'Users',
  //   icon: null,
  //   component: UserDetails,
  //   exact: true,
  //   route: 'private'
  // }
];

export default dashboardRoutes;
